module.exports = __webpack_public_path__ + "assets/img/HatTrick.0a7cd9c0.png";